// This is used to determine if a user is authenticated and
// navigate to root path otherwise, show login page.

// If already login: they proceed to root page
// If not: they proceed to login page.
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import Loading from './Loading'

const LoginRoute = ({ component: Component, ...rest }) => {
  if(rest.currentUser && rest.currentUser.isLoading) {return <Loading />}

  // Add your own authentication on the below line.
  const isLoggedIn = rest.currentUser && rest.currentUser.isSignedIn

  return (
    <Route
      {...rest}
      
      render={(props) =>
        isLoggedIn ? (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        ) : (
          <Component {...props} />
        )
      }
    />
  )
}

export default LoginRoute;


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/LoginRoute.jsx